import api from '../../../services/Api';
import { IAuditoriaEstoqueSemMovimentoResultado } from '../interfaces/IAuditoriaEstoqueSemMovimento';

export const AuditoriaEstoqueSemMovimentoService = {
  buscarResultado: async (params: { empresaId: number; periodo: string | undefined })
    : Promise<IAuditoriaEstoqueSemMovimentoResultado> => {
    const response = await api.get<IAuditoriaEstoqueSemMovimentoResultado>(
      'auditoria-estoque-sem-movimento/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
